import { Box, Typography } from "@mui/material";
import React from "react";
import MainLogo from "../../assets/images/mainLogo2.png";
import { Link } from "react-router-dom";
import { ReactComponent as InstagramIcon } from "../../assets/svg/instagram-icon.svg";
import { ReactComponent as FacebookIcon } from "../../assets/svg/facebook-icon.svg";
import { ReactComponent as TiktokIcon } from "../../assets/svg/tiktok-icon.svg";
import { ReactComponent as YoutubeIcon } from "../../assets/svg/youtube-icon.svg";
import { useTranslation } from "react-i18next";
const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  return (
    <>
      <footer>
        <Box className="footer-nav">
          <Box className="mozContainer">
            <Box className="footer-container">
              <Box className="footer-columns">
                {/* Logo column */}
                <Box className="footer-col footer-col-logo">
                  <Link to="/">
                    <img
                      src={MainLogo}
                      alt="i-moz-logo"
                      className="logo-img-footer"
                    />
                  </Link>
                </Box>

                {/* Company links */}
                <Box className="footer-col">
                  <Typography
                    variant="xsSize"
                    className="black-color font-w-500 footer-col-heading"
                  >
                    {t("Homepage.Company")}
                  </Typography>
                  <Box className="footer-col-links">
                    <Link to="/">
                      <Typography variant="xxsSize" className="font-w-400 gray-color mozFooterNavTypo">
                        {t("home")}
                      </Typography>
                    </Link>
                    <Link to="/home-properties">
                      <Typography variant="xxsSize" className="font-w-400 gray-color mozFooterNavTypo">
                        {t("Properties")}
                      </Typography>
                    </Link>
                    <Link to="/services">
                      <Typography variant="xxsSize" className="font-w-400 gray-color mozFooterNavTypo">
                        {t("services")}
                      </Typography>
                    </Link>
                    <Link to="/about">
                      <Typography variant="xxsSize" component="div" className="font-w-400 gray-color mozFooterNavTypo">
                        {t("about")}
                      </Typography>
                    </Link>
                    <Link to="/contact">
                      <Typography variant="xxsSize" className="font-w-400 gray-color mozFooterNavTypo">
                        {t("contact")}
                      </Typography>
                    </Link>
                  </Box>
                </Box>

                {/* Contact column */}
                <Box className="footer-col">
                  <Typography
                    variant="xsSize"
                    className="black-color font-w-500 footer-col-heading"
                  >
                    {t("contact")}
                  </Typography>
                  <Box className="footer-col-links">
                    <a href="tel:+258123456789" style={{ textDecoration: "none" }}>
                      <Typography variant="xxsSize" className="font-w-400 gray-color mozFooterNavTypo">
                        +258-123456789
                      </Typography>
                    </a>
                    <a href="mailto:suporte@easyproperty.co.mz" style={{ textDecoration: "none" }}>
                      <Typography variant="xxsSize" className="font-w-400 gray-color mozFooterNavTypo">
                        suporte@easyproperty.co.mz
                      </Typography>
                    </a>
                  </Box>
                </Box>

                {/* Address column */}
                <Box className="footer-col">
                  <Typography
                    variant="xsSize"
                    className="black-color font-w-500 footer-col-heading"
                  >
                    {t("Homepage.Our address")}
                  </Typography>
                  <Box className="footer-col-links">
                    <a
                      href="https://www.google.com/maps/search/?api=1&query=Rua+Desportistas+N%C2%BA833+9%C2%BA+Andar+Maputo+Mozambique"
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      <Typography variant="xxsSize" className="font-w-400 gray-color mozFooterNavTypo">
                        Rua Desportistas Nº833, 9º Andar Maputo, Mozambique
                      </Typography>
                    </a>
                  </Box>
                </Box>
              </Box>
              <Box className="footer-copyright-container text-center">
                <Typography
                  variant="xxxsSize"
                  className="font-w-400 gray-color line-h-extended"
                >
                  {t("Copyright")}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <Link to="/terms-conditions">
                    <Typography
                      variant="xxxsSize"
                      className="font-w-400 gray-color line-h-extended mozFooterNavTypo"
                    >
                      Terms & Conditions
                    </Typography>
                  </Link>
                  <Typography
                    variant="xxxsSize"
                    className="font-w-400 gray-color line-h-extended"
                  >
                    |
                  </Typography>
                  <Link to="/privacy-policy">
                    <Typography
                      variant="xxxsSize"
                      className="font-w-400 gray-color line-h-extended mozFooterNavTypo"
                    >
                      Privacy Policy
                    </Typography>
                  </Link>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </footer>
    </>
  );
};

export default Footer;
